// extracted by mini-css-extract-plugin
export default {"loginBlock":"ForgotPasswordLayout_loginBlock__6ZW2G","loginTitle":"ForgotPasswordLayout_loginTitle__KoMW+","logo":"ForgotPasswordLayout_logo__qCMyK"};